<template>
	<inertia-head title="Mutual Funds Table" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Mutual Funds Table</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Invest with confidence. The Mutual Fund Table from Truly Rich Club makes it easy to find the right fund for you! Our hand-picked selection of funds are exclusive to our members and have been carefully selected by experts. With this comprehensive guide, you can easily see which funds are the best to invest in, helping you make informed decisions with your money. Make sure your investments always pay off with the Mutual Fund Table from Truly Rich Club!
					</h2>
					
				</div>
			</div>
		</div>
	</div>
	<div class="content mt-5">
		<div class="block block-rounded">
			<div class="block-content block-content-full">
				<!-- <div v-if="user.current_rank === 'SILVER'">
					<div class="alert alert-warning">
						<p class="mb-0 fw-semibold">
							UPGRADE to GOLD or HIGHER to view Mutual Funds Table.
						</p>
					</div>
				</div> -->
				<div>
					<div class="table-responsive">
						<table class="table table-striped table-borderless table-vcenter">
							<thead class="fs-sm">
								<tr>
									<th>Fund Code</th>
									<th>Fund Name</th>
									<th class="text-end">Recommendation</th>
								</tr>
							</thead>
							<tbody class="fs-sm">
								<tr v-for="(mf, index) in mf_table.data" :key="mf.fundcode">
									<td nowrap="" class="fw-bold">{{mf.fundcode}}</td>
									<td>{{mf.fund}}</td>
									<td class="text-end">
										<span class="fw-semibold" 
											:class="{
												'text-success':mf.actiontotake=='Continue Buying',
												'text-danger':mf.actiontotake=='Stop Buying',
												'text-elagance':mf.actiontotake=='Sell',
												'text-warning':mf.actiontotake=='Hold'
											}"
											>
											<small>{{mf.actiontotake}}</small>
										</span>
									</td>
								</tr>
								<tr v-if="mf_table.data.length == 0">
									<td colspan="3">
										<p class="m-2 fw-semibold text-center text-danger">NO RECORD FOUND</p>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

import { onMounted, ref, watch } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import AuthLayout from '../../../Layouts/AuthLayout';

export default {
	layout: AuthLayout,
	props: {
		user		: Object,
		mf_table	: Object,
		filters 	: Object
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const query 	= ref(props.filters.query);

		const per_page 	= ref(props.filters.per_page ?? 5);

		watch(
			query,
			function (value) {
				var param = { per_page : per_page.value };

				if(value!='')
				{
					param.query = value;
				}

				Inertia.get(
					'/member/recommendations/mutual-funds', param,
					{
						// replace: true,
						preserveState: true,
						preserveScroll: true,
						only: ['mf_table', 'filters']
					}
				)
			}
		)

		watch(per_page, (value) => {
			var param = { per_page : value };

			if(query.value!='')
			{
				param.query = query.value;
			}

			Inertia.get(
				'/member/recommendations/mutual-funds', param,
				{
					// replace: true,
					preserveState: true,
					preserveScroll: true,
					only: ['mf_table', 'filters']
				}
			)
		})

		return{
			query,
			per_page
		}
	},
}
</script>
